export const AUTH_LOGIN_UI = 'AUTH_LOGIN_UI';
export const AUTH_SIGNUP_UI = 'AUTH_SIGNUP_UI';
export const AUTH_REQUEST_RESET_PASSWORD_UI = 'AUTH_REQUEST_RESET_PASSWORD_UI';
export const AUTH_RESET_PASSWORD_EMAIL_SENT_UI =
  'AUTH_RESET_PASSWORD_EMAIL_SENT_UI';
